
  <h3 mat-dialog-title [innerHtml]="('MODAL.title.delete_saved_signature_too') | translate"></h3>


<mat-dialog-content *ngIf="data.gifLoader; else noGifLoader"><img [src]="'/assets/images/loading.gif'" ></mat-dialog-content>
<mat-dialog-actions >
    <button mat-button (click)="closeDialog(ModalResponse.CLICK_YES)">{{'GLOBAL.yes' | translate }}</button>
    <button mat-button (click)="closeDialog(ModalResponse.CLICK_NO)">{{'GLOBAL.no' | translate }}</button>
</mat-dialog-actions>

<ng-template #noGifLoader><br><br></ng-template>
